export class AppraisalSurchargesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAppraisalSurcharges(params) {
    return this.#http.get('/api/appraisal-surcharges', { params });
  }

  async getAppraisalSurcharge({ id, ...params }) {
    return this.#http.get(`/api/appraisal-surcharges/${id}`, { params });
  }

  async createAppraisalSurcharge(body) {
    return this.#http.post('/api/appraisal-surcharges', body);
  }

  async updateAppraisalSurcharge({ id, ...body }) {
    return this.#http.put(`/api/appraisal-surcharges/${id}`, body);
  }

  async deleteAppraisalSurcharge({ id }) {
    return this.#http.delete(`/api/appraisal-surcharges/${id}`);
  }
}
